export default "__VITE_ASSET__Ddx4oAwN__"